export const sidebar = theme => ({
  '&:before': {
    backgroundImage: `linear-gradient(180deg, ${theme.variables.colors.sidebarBackground} 8%, ${theme.variables.colors.sidebarBackgroundGradientSecond} 125%)`,
  },
})
